<app-nav titulo="Propiedades" descripcion="Aquí podrá ver, editar y borrar todas las propiedades activas en el sistema.">
    <div class="properties">
        <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
        <app-data-table
            [rows]="properties"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updateProperties($event)"
            (sortFn)="updateSort($event)"
        ></app-data-table>
        <button mat-raised-button class="garantor-button add-button" color="primary" routerLink="./nueva" *ngIf="userType === 'AGENTE' || userType === 'CORPORATIVO'">
            <mat-icon matPrefix class="add-button-icon">add</mat-icon>
            <span class="add-button-label">Nueva propiedad</span>
        </button>
    </div>
</app-nav>
<ng-template #buttonsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-icon-button matTooltip="Ver detalles" class="view-more-row-button" [routerLink]="'./' + row.id">
            <mat-icon color="primary">dehaze</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Editar propiedad" class="edit-row-button" [routerLink]="'./' + row.id + '/editar'" *ngIf="userType === 'AGENTE' || userType === 'CORPORATIVO'">
            <mat-icon color="primary">edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Borrar propiedad" class="delete-row-button" (click)="deleteProperty(row)" *ngIf="userType === 'AGENTE' || userType === 'CORPORATIVO'">
            <mat-icon color="accent">delete</mat-icon>
        </button>
    </div>
</ng-template>
